__turbopack_context__.v({
  "actions": "_85iS0a_actions",
  "backdrop": "_85iS0a_backdrop",
  "close": "_85iS0a_close",
  "dialog": "_85iS0a_dialog",
  "dialogBody": "_85iS0a_dialogBody",
  "dialogHead": "_85iS0a_dialogHead",
  "dialogPrivacy": "_85iS0a_dialogPrivacy",
  "dialogTitle": "_85iS0a_dialogTitle",
  "ghost": "_85iS0a_ghost",
  "note": "_85iS0a_note",
  "primary": "_85iS0a_primary",
  "secondary": "_85iS0a_secondary",
  "trigger": "_85iS0a_trigger",
  "triggerLabel": "_85iS0a_triggerLabel",
});
